import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import Api from 'services/Api';
import Auth from 'modules/Auth';
import { isLoading as isActionLoading } from 'lib/redux-utils';

export const useMultiFactorLogin = () => {
  const dispatch = useAppDispatch();
  const [defaultMethod, setDefaultMethod] = useState('');
  const [error, setError] = useState<string | null>(null);

  const multiFactorAuthentication = useAppSelector(Auth.selectors.getMultiFactorAuthentication);

  const isLoading = useAppSelector((state) => isActionLoading(state, [Auth.AT.LOGIN._]));

  const username = useAppSelector(Auth.selectors.getUsername);

  const password = useAppSelector(Auth.selectors.getPassword);

  useEffect(() => {
    if (multiFactorAuthentication?.mfaCodeDeliveredTo) {
      setDefaultMethod(multiFactorAuthentication.mfaCodeDeliveredTo);
    }
  }, [multiFactorAuthentication?.mfaCodeDeliveredTo]);

  const makeLoginRequest = useCallback(
    async (params: FormData) => {
      if (!username || !password) {
        throw new Error('Missing username or password');
      }

      params.append('username', username);
      params.append('password', password);
      try {
        await Api.actions.auth.login(null, params)(dispatch, true);
      } catch (err: unknown) {
        const typedError = err as { message: string };
        setError(typedError?.message ?? 'An unexpected error occurred');
        throw typedError;
      }
    },
    [username, password, dispatch]
  );

  return {
    makeLoginRequest,
    isLoading,
    error,
    multiFactorAuthentication: {
      ...multiFactorAuthentication,
      mfaCodeDeliveredTo: defaultMethod
    }
  };
};
